import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import Subnav from 'containers/subnav';
import LandingPage from 'containers/landing-page';
import PlaybackPage from 'containers/playback-page';

class App extends Component {

    constructor(props) {

        super(props);

    }

    componentDidMount() {

        const { loadApp } = this.props;

        loadApp();

    }

    render() {

        const { isApp } = this.props;

        return (
            <Fragment>
                { !isApp && <Subnav/> }
                <Switch>
                    <Route exact path="/" component={LandingPage} />
                    <Route path="/topic/:topicId" component={LandingPage} />
                    <Route path="/:contentId" component={PlaybackPage} />
                </Switch>
            </Fragment>
        );

    }

}

App.propTypes = {
    loadApp: PropTypes.func.isRequired,
    isApp: PropTypes.bool,
};

App.defaultProps = {
    isApp: false,
};

export default App;